const state = {
  coloringData: {},
  coloringActive: false,
};

const mutations = {
  CHANGE_COLORING_CONTENT(state, coloringObj) {
    state.coloringData = coloringObj;
  },
  CHANGE_COLORING_ACTIVE(state, coloringActive) {
    state.coloringActive = coloringActive;
  },
};

const actions = {
  someAsyncTask({ commit }) {
    // do something async
    commit('TEST');
  },
};

const getters = {
  coloringData: (state) => {
    return state.coloringData;
  },
  coloringActive: (state) => {
    return state.coloringActive;
  },
};
export default {
  state,
  mutations,
  actions,
  getters,
};
